export enum NpsUserKind {
  ADMIN = "admin",
  DONOR = "donor",
}
